import { render, staticRenderFns } from "./logwood-inventory.vue?vue&type=template&id=74fd1890&scoped=true&"
import script from "./logwood-inventory.vue?vue&type=script&lang=ts&"
export * from "./logwood-inventory.vue?vue&type=script&lang=ts&"
import style0 from "./logwood-inventory.vue?vue&type=style&index=0&id=74fd1890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fd1890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74fd1890')) {
      api.createRecord('74fd1890', component.options)
    } else {
      api.reload('74fd1890', component.options)
    }
    module.hot.accept("./logwood-inventory.vue?vue&type=template&id=74fd1890&scoped=true&", function () {
      api.rerender('74fd1890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/views/logwood-inventory.vue"
export default component.exports